export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7718.5e0d5602.jpg";